import axios from 'axios';
import type { Campanha, InboxMsg } from '@eleg360/types';

const API_URL = import.meta.env.VITE_API_URL || '/api';

export const campanhasApi = {
  create: async (
    data: {
      nome: string;
      tipo: 'comunicacao' | 'estrategica';
      publico_def: Record<string, any>;
      template_id?: string;
      mensagem_texto: string;
      agendada_para?: string;
    },
    token: string,
  ) => {
    const res = await axios.post<Campanha>(`${API_URL}/gab/campanhas`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  list: async (token: string) => {
    const res = await axios.get<Campanha[]>(`${API_URL}/gab/campanhas`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  get: async (id: string, token: string) => {
    const res = await axios.get<Campanha>(`${API_URL}/gab/campanhas/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  approve: async (id: string, token: string) => {
    const res = await axios.post<Campanha>(
      `${API_URL}/gab/campanhas/${id}/approve`,
      {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return res.data;
  },

  getInbox: async (token: string) => {
    const res = await axios.get<InboxMsg[]>(`${API_URL}/gab/campanhas/inbox`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  simulateIncomingMessage: async (
    data: {
      remetente_telefone: string;
      mensagem_texto: string;
      remetente_nome?: string;
    },
    token: string,
  ) => {
    const res = await axios.post<{ success: boolean; optoutProcessed: boolean }>(
      `${API_URL}/gab/campanhas/webhook-receber`,
      data,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return res.data;
  },
};
